<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <b-form v-on:submit.prevent="onSubmit">
          <h1 tabindex="0">Novo Certificado</h1>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group label="Nome: *">
                <b-input-group class="mb-3">
                  <b-form-input type="text"
                                class="form-control"
                                placeholder="Nome"
                                autocomplete="nome"
                                v-model="form.nome"
                                :state="chkState('nome')"
                                autofocus/>
                  <b-form-invalid-feedback id="input1LiveFeedback1">Nome é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>        
            <b-col sm="12" md="6">
              <b-form-group label="Título: *">
                <b-input-group class="mb-3">
                  <b-form-input type="text"
                                class="form-control"
                                placeholder="Título"
                                autocomplete="titulo"
                                v-model="form.titulo"
                                :state="chkState('titulo')"
                                autofocus/>
                  <b-form-invalid-feedback id="input1LiveFeedback1">Título é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>     
            <b-col sm="4">
              <b-form-group label="Inserir Imagem de Assinatura: *" for="img_assinatura">               
                <b-form-file id="img_assinatura" ref="img_assinatura"  v-model="form.img_assinatura" v-on:change="uploadFileAssinatura" :state="chkState('img_assinatura')" placeholder="Escolha um arquivo..." browse-text="Selecionar"/>
                <b-form-invalid-feedback id="input1LiveFeedback9">Arquivo é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
              <b-col sm="4">
              <b-form-group label="Inserir Imagem de Rodapé: *" for="img_rodape">               
                <b-form-file id="img_rodape" ref="img_rodape"  v-model="form.img_rodape" v-on:change="uploadFileRodape" :state="chkState('img_rodape')" placeholder="Escolha um arquivo..." browse-text="Selecionar"/>
                <b-form-invalid-feedback id="input1LiveFeedback9">Arquivo é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
              <b-col sm="4">
              <b-form-group label="Inserir Imagem de Certificado: *" for="img_certificado">               
                <b-form-file id="img_certificado" ref="img_certificado"  v-model="form.img_certificado" v-on:change="uploadFileCertificado" :state="chkState('img_certificado')" placeholder="Escolha um arquivo..." browse-text="Selecionar"/>
                <b-form-invalid-feedback id="input1LiveFeedback9">Arquivo é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
          <b-col cols="12">
            <b-form-group label="Texto complementar do Certificado: ">
              <b-form-textarea                          
                :state="chkState('texto_certificado')" 
                v-model="form.texto_certificado"             
                rows="5"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group> 
          </b-col>
        </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col v-if="!loading" md="3">
            <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
              <i class="fa fa-plus"></i>&nbsp;
              <span>Salvar</span>
            </b-button>
          </b-col>
          <b-col v-else md="3">
            <b-button block variant="primary" :disabled="true" v-on:click="onSubmit">
              <b-spinner small type="grow"></b-spinner>Salvando...
            </b-button>
          </b-col>
          <b-col md="3">
            <b-button block variant="secondary" :disabled="disable_buttons" @click="voltar()">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required, requiredIf} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'
import { VueEditor } from "vue2-editor";

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    VueSelect,
    Multiselect,
    VueEditor
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      nome: {
        required
      },
      img_assinatura: {
       required
      },
      img_rodape: {
       required
      },
      img_certificado: {
       required
      },
      status: {
        required
      },
      texto_certificado: {
        required
      }
    }
  },
  created () {
    //
  },
  data () {
    return {
      loading: false,
      form: {
        titulo: '',
        nome: '',
        img_assinatura: null,
        img_rodape: null,
        img_certificado: null,
        status: 'C',
        texto_certificado: ''
      },
      id_conferencia: SessionStorage.get('conferencia_atual_id'),
      disable_buttons: false,
      salvarForm: false
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    },
  },
  mounted () {
    //
  },
  watch: {
    //
  },
  methods: {
    salvar () {
     
      let data = {
        titulo: this.form.titulo,
        nome: this.form.nome,
        img_assinatura: this.form.img_assinatura,
        img_rodape: this.form.img_rodape,
        img_certificado: this.form.img_certificado,
        texto_certificado: this.form.texto_certificado,
        status: this.form.status      
      }
      this.loading = true

      Vue.http.post('api/certificado', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({path: '/certificados'})
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(e.data.msg, 'Alerta', 5000)
          this.loading = false
      })
    },
    uploadFileCertificado(evento, tipo = 'img_certificado'){
      this.uploadFile(evento, tipo)
    },
    uploadFileAssinatura(evento, tipo = 'img_assinatura'){
      this.uploadFile(evento, tipo)
    },
    uploadFileRodape(evento, tipo = 'img_rodape'){
      this.uploadFile(evento, tipo)
    },
    uploadFile(evento, tipo) {
      let arquivo = evento.target.files || evento.dataTransfer.files
   
      if (arquivo[0].size > 25000000) {
        if(tipo == 'img_certificado'){
            this.$refs['img_certificado'].reset()
        }  
        if(tipo == 'img_assinatura'){
           this.$refs['img_assinatura'].reset()
        }
        if(tipo == 'img_rodape'){
            this.$refs['img_rodape'].reset()
        }
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Tamanho máximo permitido para o arquivo é 25Mb.', 'Alerta', 5000)
        return false
      }

      let extensionesPermitidas = ['png','jpg', 'jpeg']
      let ext = arquivo[0].name.split('.').pop()
      let permitida = false

      for (var i = 0; i < extensionesPermitidas.length; i++) {
        if (extensionesPermitidas[i] === ext) {
          permitida = true
          break
        }
      }

      if (!permitida) {
        if(tipo == 'img_certificado'){
            this.$refs['img_certificado'].reset()
        }  
        if(tipo == 'img_assinatura'){
           this.$refs['img_assinatura'].reset()
        }
        if(tipo == 'img_rodape'){
            this.$refs['img_rodape'].reset()
        }
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Tipo de arquivo não permitido', 'Alerta', 5000)       
        return false
      }

      if (!arquivo.length) {
        return false
      } 

      let reader = new FileReader()

      if(tipo == 'img_certificado'){
          reader.onload = (evento) => {
            this.form.img_certificado = evento.target.result
          }
      }  
      if(tipo == 'img_assinatura'){
          reader.onload = (evento) => {
            this.form.img_assinatura = evento.target.result
          }
      }
      if(tipo == 'img_rodape'){
          reader.onload = (evento) => {
            this.form.img_rodape = evento.target.result
          }
      }
      reader.readAsDataURL(arquivo[0])
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    voltar(){
      if(this.form.titulo !== '' || this.form.nome !== '' || this.form.img_assinatura !== null || this.form.img_rodape !== null || this.form.img_certificado !== null || this.form.texto_certificado !== ''){
          this.$bvModal.msgBoxConfirm('Tem certeza que deseja voltar? As informações inseridas serão perdidas.', {
            okTitle: 'Confirmar',
            cancelTitle: 'Cancelar'
          }).then(valor => {
            if (valor) {
              this.$router.push('/certificados')
            }
          })
      }else{
         this.$router.push('/certificados')
      }
    },
    onSubmit () {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      if (!field && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    },

  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/certificados/CertificadoCadastrar.vue